import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import * as ProductActions from '../actions/productAction';
import * as ProductService from './../services/productService';
import Product from '../models/Product';
import { PATHS } from '../constants/Define';
import history from '../helpers/history';


function* getListProduct() {
    yield takeLatest(Types.PRODUCT_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(ProductService.getProducts, params);
        yield put(ProductActions.dataProductSuccess(result));
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* getAllProduct() {
    yield takeLatest(Types.PRODUCT_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(ProductService.getAllProducts);
        yield put(ProductActions.dataAllProductSuccess(result));
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* getProductDetail() {
    yield takeLatest(Types.PRODUCT_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(ProductService.getProductDetail, action.params.id);
        yield put(ProductActions.getUpdateProductSuccess(result));
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* createProduct() {
    yield takeLatest(Types.PRODUCT_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const product = (action.params.data)
        yield call(ProductService.createProduct, product);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), product.name);
        history.push(PATHS.PRODUCT.LIST.path);
        history.go();
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* updateProduct() {
    yield takeLatest(Types.PRODUCT_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const product = (action.params.data);
        yield call(ProductService.updateProduct, product);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), product.name);
        yield put({ type: Types.PRODUCT_UPDATE_SUCCESS });
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* deleteProduct() {
    yield takeLatest(Types.PRODUCT_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ProductService.deleteProduct, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.PRODUCT_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

// TRANSLATE
function* createProductTranslate() {
    yield takeLatest(Types.PRODUCT_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ProductService.createProductTranslate, action.product);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.product.translate.languageName);
        yield put({ type: Types.PRODUCT_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PRODUCT_GET_UPDATE_ACTION, params: { id: action.product.id } });
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* updateProductTranslate() {
    yield takeLatest(Types.PRODUCT_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ProductService.updateProductTranslate, action.product);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.product.translate.languageName);
        yield put({ type: Types.PRODUCT_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PRODUCT_GET_UPDATE_ACTION, params: { id: action.product.id } });
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function* deleteProductTranslate() {
    yield takeLatest(Types.PRODUCT_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ProductService.deleteProductTranslate, action.product.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.product.translate.languageName);
        yield put({ type: Types.PRODUCT_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PRODUCT_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleProduct(Types.PRODUCT_FAIL)))
}

function errorHandleProduct(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'product');
}

export function* productSaga() {
    yield all([
        fork(getListProduct),
        fork(getAllProduct),
        fork(createProduct),
        fork(deleteProduct),
        fork(getProductDetail),
        fork(updateProduct),
        fork(createProductTranslate),
        fork(updateProductTranslate),
        fork(deleteProductTranslate),
    ])
}
